import { EntityPropertyMetadataModel, ParameterMetadata, ParameterType, PrimitiveType } from '../../../../api/api';
import { ObjectPropertyType } from '../../Models/ObjectPropertyType';

// Helper functions

export function getPropertyParameterMetadata(property: EntityPropertyMetadataModel): ParameterMetadata {
	return {
		name: property.name,
		displayName: property.name,
		type: ParameterType.Expression,
		expectedType: { type: property.referenceEnum ? PrimitiveType.String : property.type, typeJsonSchema: (property as ObjectPropertyType).jsonSchema },
		isRequired: property.isRequired,
		order: 0,
		isCollection: property.isMultiple,
	} as ParameterMetadata;
}
